import { useState } from "react";
import "./Common.css";
import "./ArduinoClock.css";

function ArduinoClock() {
  const [copyState, setCopyState] = useState("Copy code");

  const circuitDiagram =
    "https://1drv.ms/i/c/c94efc88b6ce9f63/IQS6-0DpqBfvTrCsF-KJklfaAQP9rlawgB9LqqkGfEmTmQo";
  const pcbLayout =
    "https://1drv.ms/i/c/c94efc88b6ce9f63/IQRf2TLrrCwoQZVx4WQl1z2zAcC_XdXIPgYZv-iTM4CcbZY";
  const frontcir =
    "https://1drv.ms/i/c/c94efc88b6ce9f63/IQQyBjzGp4L2S4dYii0nxTYLAcjsFv4o5XGDx0k8h2Vc2UI?width=2349&height=3824";
  const backcir =
    "https://1drv.ms/i/c/c94efc88b6ce9f63/IQRoltwSXXkqQJTnN7SUX4LAAcrSkIPEY8hLEakiP1Khkmo?width=2406&height=3948";
  const frontoncir =
    "https://1drv.ms/i/c/c94efc88b6ce9f63/IQRaQ77fjOlCRLsO_CNM_72LAeILtv3tA9wI32-_AWrcMTM?width=2550&height=4028";
  const videoLink =
    "https://1drv.ms/v/c/c94efc88b6ce9f63/IQShsT2X5ArfQJcc19brwMNhAd43PUmeLaYFNRlAeUJfZsU?width=1920&height=1080Z";

  const arduinoClockCode = `#include <Wire.h>
#include <RTClib.h>

#define select A0
#define setPin A1
#define battervolt A2

RTC_DS3231 rtc;

int t_dataPin = 2;  // DS
int t_latchPin = 3; // ST_CP
int t_clockPin = 4; // SH_CP

int d_dataPin = 5;  // DS
int d_latchPin = 6; // ST_CP
int d_clockPin = 7; // SH_CP

unsigned long previousMillis = 0;
const long btinterval = 100;
enum DisplayMode {
  MODE_DATE,
  MODE_TEMP,
  MODE_VOLT
};
DisplayMode mode = MODE_DATE;
unsigned long lastSwitch = 0;
const unsigned long displayInterval = 5000;

// Digits mapping
const byte numbers[14] = {
    0b01111011, // 0
    0b00011000, // 1
    0b11010011, // 2
    0b11011010, // 3
    0b10111000, // 4
    0b11101010, // 5
    0b11101011, // 6
    0b01011000, // 7
    0b11111011, // 8
    0b11111010, // 9
    0b00000100, // dp
    0b10000000, // minus sign
    0b01100011, // degree symbol
    0b00111011  // V
};
// Segment mapping
const byte segments[8] = {
    0b00000001,
    0b00000010,
    0b00000100,
    0b00001000,
    0b00010000,
    0b00100000,
    0b01000000,
    0b10000000};

void setup()
{
  pinMode(t_dataPin, OUTPUT);
  pinMode(t_clockPin, OUTPUT);
  pinMode(t_latchPin, OUTPUT);

  pinMode(d_dataPin, OUTPUT);
  pinMode(d_clockPin, OUTPUT);
  pinMode(d_latchPin, OUTPUT);

  pinMode(select, INPUT); // Mode switch pin
  pinMode(setPin, INPUT); // Set pin
  pinMode(battervolt, INPUT); // Battery voltage pin

  Serial.begin(9600);

  if (!rtc.begin())
  {
    Serial.println("Couldn't find RTC");
    while (1)
      ;
  }
  // rtc.adjust(DateTime(F(__DATE__), F(__TIME__)));
}

void showtnum(int number, int digit, bool dp = false){
  digitalWrite(t_latchPin, LOW);
  shiftOut(t_dataPin, t_clockPin, MSBFIRST, ~(dp ? numbers[10] | numbers[number] : numbers[number]));
  shiftOut(t_dataPin, t_clockPin, MSBFIRST, ~segments[digit]);
  digitalWrite(t_latchPin, HIGH);
  delayMicroseconds(100);
  digitalWrite(t_latchPin, LOW);
  shiftOut(t_dataPin, t_clockPin, MSBFIRST, ~(dp ? numbers[10] | numbers[number] : numbers[number]));
  shiftOut(t_dataPin, t_clockPin, MSBFIRST, 0xFF);
  digitalWrite(t_latchPin, HIGH);
  delayMicroseconds(5);
}

void showdnum(int number, int digit, bool dp = false){
  digitalWrite(d_latchPin, LOW);
  shiftOut(d_dataPin, d_clockPin, MSBFIRST, (dp ? numbers[10] | numbers[number] : numbers[number]));
  shiftOut(d_dataPin, d_clockPin, MSBFIRST, segments[digit]);
  digitalWrite(d_latchPin, HIGH);
  delayMicroseconds(100);
  digitalWrite(d_latchPin, LOW);
  shiftOut(d_dataPin, d_clockPin, MSBFIRST, (dp ? numbers[10] | numbers[number] : numbers[number]));
  shiftOut(d_dataPin, d_clockPin, MSBFIRST, 0x00);
  digitalWrite(d_latchPin, HIGH);
  delayMicroseconds(5);
}

void showtime(DateTime now){
  byte hour = now.hour();
  byte minute = now.minute();
  byte second = now.second();

  showtnum(second % 10, 0);
  showtnum(second / 10, 1);
  showtnum(minute % 10, 2, true);
  showtnum(minute / 10, 3);

  if(hour > 12) hour -= 12;
  if(hour == 0) hour = 12;

  showtnum(hour % 10, 4, true);
  showtnum(hour / 10, 5);
}

void showdate(DateTime now){
  byte year = now.year() - 2000;
  byte month = now.month();
  byte day = now.day();
  
  showdnum(day % 10, 0);
  showdnum(day / 10, 1);
  showdnum(month % 10, 2, true);
  showdnum(month / 10, 3);
  showdnum(year % 10, 4, true);
  showdnum(year / 10, 5);
  showdnum(0, 6);
  showdnum(2, 7);
}

void settime(DateTime now)
{
  DateTime set = DateTime();
  showtime(now);
  byte ss = now.second();
  byte mm = now.minute();
  byte hh = now.hour();
  byte dd = now.day();
  byte MM = now.month();
  byte yy = now.year() - 2000;

  // update seconds
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        ss += 1;
        if (ss >= 60)
        {
          ss = 0;
        }
        delay(10);
      }
    }
    set = DateTime(now.year(), now.month(), now.day(), now.hour(), now.minute(), ss);
    showtime(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  // update minutes
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        mm += 1;
        if (mm >= 60)
        {
          mm = 0;
        }
        delay(10);
      }
    }
    set = DateTime(now.year(), now.month(), now.day(), now.hour(), mm, ss);
    showtime(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  // update hours
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        hh += 1;
        if (hh >= 24)
        {
          hh = 0;
        }
        delay(10);
      }
    }
    set = DateTime(now.year(), now.month(), now.day(), hh, mm, ss);
    showtime(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  showdate(set);
  // update day
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        dd += 1;
        if (dd > 31)
        {
          dd = 1;
        }
        delay(10);
      }
    }
    set = DateTime(now.year(), now.month(), dd, hh, mm, ss);
    showdate(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  // update month
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        MM += 1;
        if (MM > 12)
        {
          MM = 1;
        }
        delay(10);
      }
    }
    set = DateTime(now.year(), MM, dd, hh, mm, ss);
    showdate(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  // update year
  while (true)
  {
    if (millis() - previousMillis >= btinterval)
    {
      previousMillis = millis();
      if (digitalRead(setPin) == HIGH)
      {
        yy += 1;
        if (yy > 55)
        {
          yy = 0;
        }
        delay(10);
      }
    }
    set = DateTime(2000 + yy, MM, dd, hh, mm, ss);
    showdate(set);
    if (digitalRead(select) == HIGH)
    {
      delay(200);
      break;
    }
  }

  // writer to RTC
  rtc.adjust(DateTime(2000 + yy, MM, dd, hh, mm, ss));
}

void showtemp(float temperature){
  int tempInt = (int)temperature;
  int tempFrac = (int)((temperature - tempInt) * 100);

  showdnum(12, 0); // degree symbol
  showdnum(abs(tempFrac) % 10, 2);
  showdnum(abs(tempFrac) / 10, 3);
  showdnum(abs(tempInt) % 10, 4, true);
  showdnum(abs(tempInt) / 10, 5);
  
}

void showvoltage(float voltage){
  int voltInt = (int)voltage;
  int voltFrac = (int)((voltage - voltInt) * 100);

  showdnum(13, 0);
  showdnum(voltFrac % 10, 2);
  showdnum(voltFrac / 10, 3);
  showdnum(voltInt % 10, 4, true);
}

void loop() {
  DateTime now = rtc.now();
  float temperature = rtc.getTemperature();
  float voltage = analogRead(battervolt) * (3.3 / 1023.0) * 2;
  
  // ---------- MODE SWITCHING ----------
  if (millis() - lastSwitch >= displayInterval) {
    lastSwitch = millis();

    if (mode == MODE_DATE) {
      mode = MODE_TEMP;
    } else if (mode == MODE_TEMP) {
      mode = MODE_VOLT;
    } else {
      mode = MODE_DATE;
    }
  }

  // ---------- ALWAYS SHOW TIME ----------
  showtime(now);

  // ---------- MODE DISPLAY ----------
  switch (mode) {
    case MODE_DATE:
      showdate(now);
      break;

    case MODE_TEMP:
      showtemp(temperature);
      break;

    case MODE_VOLT:
      showvoltage(voltage);
      break;
  }

  // ---------- SET TIME BUTTON ----------
  if (digitalRead(select) == HIGH) {
    delay(200);   // debounce
    settime(now);
  }
}`;

  const openImageInNewWindow = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const copyArduinoCode = async () => {
    try {
      await navigator.clipboard.writeText(arduinoClockCode);
      setCopyState("Copied!");
      setTimeout(() => setCopyState("Copy code"), 1800);
    } catch (error) {
      console.error("Copy failed", error);
      setCopyState("Press Ctrl+C");
      setTimeout(() => setCopyState("Copy code"), 1800);
    }
  };

  const renderFigure = (url, alt, caption) => (
    <figure className="media-figure">
      <div className="media-figure__visual">
        <img src={url} alt={alt} loading="lazy" />
        <button
          type="button"
          className="view-full-button"
          onClick={() => openImageInNewWindow(url)}
        >
          View full image
        </button>
      </div>
      {caption ? (
        <figcaption className="figcaption-text">{caption}</figcaption>
      ) : null}
    </figure>
  );

  return (
    <main className="content">
      <section className="section arduino-clock">
        <h1 className="text-head">
          Arduino-Based Multi-Function Digital Clock
        </h1>
        <p className="project-text">
          This project presents a custom-designed Arduino-based Digital Clock
          System that integrates real-time clock functionality, temperature
          monitoring, and battery voltage measurement into a single embedded
          system. The system was developed as a practical application of digital
          electronics, analog electronics, embedded programming, and
          communication protocols.
        </p>
        <p className="project-text">
          The clock displays real-time hours, minutes, and seconds, while
          automatically switching between date, temperature, and voltage display
          modes. The entire system was designed, programmed, and assembled from
          scratch, including schematic design, PCB layout, and hardware
          implementation.
        </p>
        <br />
        <br />

        <h1 className="text-head">System Architecture</h1>
        <p className="project-text">
          The system is built around an Arduino Nano (ATmega328P)
          microcontroller, which acts as the central processing unit. It
          communicates with a DS3231 Real-Time Clock (RTC) module via the I2C
          protocol to obtain accurate time and temperature data.
        </p>
        <p className="project-text">
          To efficiently drive multiple 7-segment displays while minimizing I/O
          pin usage, 74HC595 shift registers are used for serial-to-parallel
          data conversion. The display system uses time-division multiplexing to
          refresh digits rapidly, creating a stable and flicker-free output.
        </p>
        <p className="project-text">The device also includes:</p>
        <ul className="project-text">
          <li>Manual time and date adjustment buttons.</li>
          <li>
            Battery voltage monitoring using analog-to-digital conversion.
          </li>
          <li>Automatic mode switching.</li>
          <li>RTC backup battery for uninterrupted timekeeping</li>
        </ul>
        <br />
        <br />

        <h1 className="text-head">Circuit & Hardware Techniques</h1>
        <p className="project-text">
          The hardware is designed to overcome the physical pin limitations of
          the Arduino Nano by using serial-to-parallel conversion and high-speed
          switching.
        </p>
        <br />
        <div className="intro-with-image">
          <ol className="project-text">
            <li>Shift Register Expansion (74HC595)</li>
            <ul>
              <li>
                The Problem: Driving 14 digits directly would require over 100
                pins.
              </li>
              <li>
                The Solution: Four 74HC595 registers are used. The Arduino sends
                data serially (one bit at a time) to the registers, which then
                hold that data as a parallel output to light the segments.{" "}
              </li>
              <li>
                Daisy Chaining: The registers are linked together, allowing a
                single "Data" pin to feed multiple chips in a row.
              </li>
            </ul>
            <br />
            <li>Multiplexing with Transistors</li>
            <p className="project-text">
              To prevent the shift registers from burning out and to reduce
              power consumption, the circuit uses Multiplexing.
            </p>
            <ul>
              <li>
                PNP/NPN Drivers: The BC557 and SN2222 transistors act as
                "gates." The Arduino rapidly cycles through each digit, turning
                one on at a time for a fraction of a millisecond.
              </li>
              <li>
                Persistence of Vision (POV): Because this happens hundreds of
                times per second, the human eye cannot see the flickering, and
                the display appears solid.
              </li>
            </ul>
            <br />
            <li>Power Management & Voltage Sensing</li>
            <ul>
              <li>
                Analog Sensing: The battervolt pin (A2) uses a voltage divider
                (implied by the * 2 in the code) to scale down a battery's
                voltage so the 5V Arduino can safely read it.
              </li>
              <li>
                Decoupling: Capacitor C3 (1uF) near the RTC and power rails
                filters out high-frequency noise that could cause the clock to
                "glitch" or reset.
              </li>
            </ul>
          </ol>

          <div className="arduino-clock-media">
            {renderFigure(
              circuitDiagram,
              "Digital door lock breadboard prototype with keypad, seven-segment displays, and control circuitry",
              "Circuit diagram of the Arduino-Based Multi-Function Digital Clock.",
            )}
          </div>
        </div>
        <br />
        <br />

        <div className="component-table">
          <table
            border="1"
            cellpadding="8"
            cellspacing="0"
            className="project-text"
            style={{ width: "100%", borderCollapse: "collapse" }}
          >
            <thead style={{ backgroundColor: "#5e93cf70" }}>
              <tr>
                <th>Component</th>
                <th>Function</th>
                <th>Use Case in Circuit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Arduino Nano (ATmega328P 8Mhz 3.3V)</td>
                <td>Microcontroller Unit</td>
                <td>
                  Acts as the main controller to manage time reading, display
                  control, mode switching, and user inputs.
                </td>
              </tr>
              <tr>
                <td>DS3231 RTC Module</td>
                <td>Real-Time Clock with Temperature Sensor</td>
                <td>
                  Provides accurate time, date, and temperature data using I2C
                  communication.
                </td>
              </tr>
              <tr>
                <td>74HC595 Shift Register</td>
                <td>Serial-to-Parallel Converter</td>
                <td>
                  Expands Output pins and drives 7-segment displays using serial
                  communication.
                </td>
              </tr>
              <tr>
                <td>7-Segment Display</td>
                <td>Numeric Display</td>
                <td>Displays time, date, temperature, and voltage values.</td>
              </tr>
              <tr>
                <td>Select Button</td>
                <td>Mode / Setting Control</td>
                <td>
                  Used to enter time-setting mode and navigate between
                  adjustment stages.
                </td>
              </tr>
              <tr>
                <td>Set Button</td>
                <td>Increment Control</td>
                <td>
                  Increments seconds, minutes, hours, day, month, and year
                  during configuration.
                </td>
              </tr>
              <tr>
                <td>Voltage Divider (Resistors)</td>
                <td>Signal Conditioning Circuit</td>
                <td>
                  Reduces battery voltage to a safe level for Arduino ADC
                  measurement.
                </td>
              </tr>
              <tr>
                <td>Decoupling Capacitors</td>
                <td>Noise Filtering</td>
                <td>
                  Stabilizes power supply and prevents signal fluctuations in
                  ICs.
                </td>
              </tr>
              <tr>
                <td>RTC Backup Battery</td>
                <td>Power Backup Source</td>
                <td>Maintains accurate timekeeping during main power loss.</td>
              </tr>
              <tr>
                <td>Power Supply (3.7V Battery)</td>
                <td>Primary Power Source</td>
                <td>
                  Supplies operating voltage to the microcontroller and display
                  system.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <br />

        <h1 className="text-head">Code & Programming Techniques</h1>
        <div className="intro-with-code">
          <div className="arduino-clock-code-intro">
            <ol className="project-text">
              <li>State Machine Architecture</li>
              <ul>
                <li>
                  Enumerated States: The program uses an{" "}
                  <strong>enum DisplayMode</strong>
                  to define different operating modes such as Date, Temperature,
                  and Voltage.
                </li>
                <li>
                  Mode Switching with Timers: Instead of using delay(), the
                  system switches between states every 5000ms using millis(),
                  allowing the clock to continue running in the background.
                </li>
                <li>
                  Organized Logic Flow: This structure improves readability,
                  scalability, and makes debugging easier compared to a linear
                  script.
                </li>
              </ul>

              <br />

              <li>Bitmasking for 7-Segment Control</li>
              <ul>
                <li>
                  Binary Mapping: The numbers[14] array stores digit patterns
                  using binary literals (e.g., 0b01111011).
                </li>
                <li>
                  Segment Control: Each bit represents a physical segment (A, B,
                  C, D, E, F, G, DP).
                </li>
                <li>
                  Memory Efficient: Bitmasking reduces memory usage and
                  increases execution speed compared to string or decimal
                  representations.
                </li>
              </ul>

              <br />

              <li>Non-Blocking Timing Implementation</li>
              <ul>
                <li>
                  millis() Based Timing: The program uses millis() instead of
                  delay() to maintain real-time responsiveness.
                </li>
                <li>
                  Button Debouncing: Software debouncing prevents false
                  triggering caused by mechanical noise.
                </li>
                <li>
                  Concurrent Operation: While displaying date or voltage, the
                  RTC continues updating time seamlessly.
                </li>
              </ul>
            </ol>
          </div>
          <div className="arduino-clock-code">
            <div className="code-window">
              <div className="code-window__header">
                <span>Arduino sketch (DS3231 + 74HC595)</span>
                <button
                  type="button"
                  className="code-window__copy"
                  onClick={copyArduinoCode}
                >
                  {copyState}
                </button>
              </div>
              <pre className="code-window__body">
                <code>{arduinoClockCode}</code>
              </pre>
            </div>
          </div>
        </div>
        <br />
        <br />

        <h1 className="text-head">Communication Protocols</h1>
        <ol className="project-text">
          <li>I2C Communication Protocol</li>
          <ul>
            <li>
              Two-Wire Interface: Communication between Arduino and the
              <strong> DS3231 RTC module</strong> uses SDA (Data) and SCL
              (Clock).
            </li>
            <li>
              Device Addressing: Each I2C device has a unique address, ensuring
              reliable communication without signal conflicts.
            </li>
            <li>
              Data Exchange: Enables reading time, date, and internal
              temperature values from the RTC accurately.
            </li>
          </ul>

          <br />

          <li>SPI-Like Serial Communication (Shift Registers)</li>
          <ul>
            <li>
              Serial Data Transfer: Communication between Arduino and
              <strong> 74HC595 shift registers</strong> mimics the SPI protocol.
            </li>
            <li>
              Data Pin (DS): Sends serial bits (1s and 0s) representing segment
              states.
            </li>
            <li>Clock Pin (SH_CP): Synchronizes each incoming bit.</li>
            <li>
              Latch Pin (ST_CP): Transfers shifted data to the output pins
              simultaneously.
            </li>
          </ul>
        </ol>
        <br />
        <br />

        <h1 className="text-head">Implementation</h1>
        <p className="project-text">
          During the implementation stage, the circuit was first designed and
          simulated using EasyEDA, where the schematic and PCB layout were
          carefully prepared with proper routing and component placement.
          However, due to the unavailability of a copper board at the time, the
          hardware was practically developed using a dot board (veroboard). This
          approach allowed the entire circuit to be manually assembled by
          soldering individual connections according to the PCB layout design.
          The final hardware implementation successfully integrated all
          components, including the Arduino Nano, DS3231 RTC module, 74HC595
          shift registers, and 7-segment displays, resulting in a fully
          functional multi-function digital clock system. The project was tested
          and debugged to ensure accurate timekeeping, proper display
          functionality, and reliable mode switching between date, temperature,
          and voltage readings.
        </p>
        <p className="project-text">
          Building the system on a dot board not only solved the material
          limitation but also provided valuable hands-on experience in manual
          circuit wiring, track planning, and soldering techniques. It required
          careful attention to signal routing, short connections for clock
          lines, and stable grounding to ensure reliable operation. This
          experience significantly improved practical hardware skills and
          deepened understanding of real-world implementation challenges in
          embedded system development.
        </p>
        <br />
        <div className="arduinoclock__media_cir_and_pcb">
          {renderFigure(pcbLayout, "Desined PCB layout", "PCB Layout ")}
          {renderFigure(
            frontcir,
            "Hand-made Circuit on dot board front view",
            "Hand-made Circuit on dot board front view",
          )}
          {renderFigure(
            backcir,
            "Hand-made Circuit on dot board back view",
            "Hand-made Circuit on dot board back view",
          )}
          {renderFigure(
            frontoncir,
            "Hand-made Circuit on dot board back view (on)",
            "Hand-made Circuit on dot board back view (on)",
          )}
          <figure className="media-figure media-figure--video">
            <div className="media-figure__visual media-figure__visual--video">
              <iframe
                src={videoLink}
                allowFullScreen
                title="Arduino clock demo video"
                loading="lazy"
              ></iframe>
            </div>
            <figcaption className="figcaption-text">
              Video demonstration of the clock in action.
            </figcaption>
          </figure>
        </div>
        <br />
        <p className="project-text">
          Finally, a rechargeable power system was integrated to make the device
          functioning at all times without external power sources. A 3.7V
          lithium-ion battery was added along with a TP4056 charging module to
          enable safe and efficient USB charging with built-in overcharge and
          discharge protection. A power switch was used to allow manual control
          of the system’s power supply. Proper wiring and insulation were
          ensured to maintain stable voltage delivery to the Arduino and
          peripheral components. This final enhancement improved the
          practicality, reliability, and real-world usability of the digital
          clock system.
        </p>
      </section>
    </main>
  );
}

export default ArduinoClock;
